import { render, staticRenderFns } from "./MbMatchesByJudge.vue?vue&type=template&id=24ffa647"
import script from "./MbMatchesByJudge.vue?vue&type=script&lang=js"
export * from "./MbMatchesByJudge.vue?vue&type=script&lang=js"
import style0 from "./MbMatchesByJudge.vue?vue&type=style&index=0&id=24ffa647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports